import React from 'react';

import InforPreview from '../../../../../../../../../common/InforPreview';
import SimulationDoneFrozen from '../../../../../../../../../common/SimulationDoneFrozen';
import DialogActionsWrapper from '../DialogActionWrapper';

const ShoppingCartFactoringInTransfer = (props: any) => {
  const {
    setOpenShoppingCart,
    selectedRequest,
    setSelectedRequest,
    setUp,
    selectedId,
    executivesPortfolio,
    executivesAll,
  } = props;

  const infoDiv = (
    <InforPreview
      requestType="factoring"
      type="Recieved"
      status="En giro"
      selectedRequest={selectedRequest}
      setSelectedRequest={setSelectedRequest}
      setUp={setUp}
      executivesPortfolio={executivesPortfolio}
      executivesAll={executivesAll}
    />
  );

  return (
    <div>
      <SimulationDoneFrozen
        selectedRequest={selectedRequest}
        infoDiv={infoDiv}
      />
      <DialogActionsWrapper
        type="factoring"
        onClose={() => setOpenShoppingCart(false)}
        selectedRequest={selectedRequest}
        status={selectedRequest.status}
        setUp={setUp}
        selectedId={selectedId}
      />
    </div>
  );
};

export default ShoppingCartFactoringInTransfer;
